import * as _ from "lodash";

import * as types from './action-types';
import { IEmailFamilyState } from "./state";
import { IEmailFamily, IEmailType, IEmailExcelId } from '../../../models/index';
//import { type } from "os";

var initialState: IEmailFamilyState = {
    list: []
}

export const Reducer = (state: IEmailFamilyState = initialState, action: any) => {
    let s = _.cloneDeep(state);

    switch (action.type) {
        case types.SET_EMAILFAMILIES:
            s.list = action.list;

            return s;

        case types.ADD_EMAILFAMILY:
            var emailFamily: IEmailFamily = { id: parseInt(action.id), name: action.name, emailTypes: [] };

            s.list.push(emailFamily);

            return s;

        case types.DELETE_EMAILFAMILY:
            s.list = s.list.filter(f => f.id != action.emailFamilyId);

            return s;

        case types.ADD_EMAILTYPE:
            var emailType: IEmailType = { ...action.emailType };
            var emailFamily = s.list.find(f => f.id == emailType.emailFamilyId);

            emailFamily.emailTypes.push(emailType);

            return s;

        case types.DELETE_EMAILTYPE:
            var emailFamily = s.list.find(f => f.id == action.emailFamilyId);

            emailFamily.emailTypes = emailFamily.emailTypes.filter(t => t.id != action.emailTypeId);

            return s;

        case types.ADD_EMAILEXCELID:
            var emailExcelId: IEmailExcelId = { ...action.emailExcelId };
            var emailFamily = s.list.find(f => f.id == action.emailFamilyId);
            var emailType = emailFamily.emailTypes.find(t => t.id == emailExcelId.emailTypeId);

            emailType.emailExcelIds.push(emailExcelId);

            return s;

        case types.DELETE_EMAILEXCELID:
            var emailFamily = s.list.find(f => f.id == action.emailFamilyId);
            var emailType = emailFamily.emailTypes.find(t => t.id == action.emailTypeId);

            emailType.emailExcelIds = emailType.emailExcelIds.filter(e => e.id != action.emailExcelId);

            return s;
    }

    return s;
}